let allSubscribeBtns = document.querySelectorAll('[data-sellingplan]');
let allOneTimeBtns = document.querySelectorAll('[data-onetime]:not([data-sellingplan])');

function handleSubscription(btn) {
    let sellingplan = btn.target.getAttribute('data-sellingplan');
    let variantId = btn.target.getAttribute('data-onetime');
    addProductToCart(variantId, 1, sellingplan);
}

function handleOnetime(btn) {
    let variantId = btn.target.getAttribute('data-onetime');
    addProductToCart(variantId, 1, false);
}

if(allSubscribeBtns) {
    allSubscribeBtns.forEach(button => {
        button.addEventListener('click', handleSubscription);
    });
}

if(allOneTimeBtns) {
    allOneTimeBtns.forEach(button => {
        button.addEventListener('click', handleOnetime);
    });
}